import { Fragment } from "react";
import { Company } from "../../../core/models/company.model";
import { IconPhone } from "../../../assets/svgs-index";
import LinkButton from "../../buttons/LinkButton/LinkButton";

const CompanyPhoneInfo = (props: { company: Company | undefined, darkMode?: boolean }) => {
  const { company, darkMode } = props;

  if (!company?.phone) {
    return <Fragment />;
  }

  return (
    <div className="company-info d-inline-flex">
      <div className="info-icon me-2">
        <img src={IconPhone} alt="address-icon" />
      </div>
      <div className="info-text">
        <LinkButton
          onClick={() => {}}
          styleClass="link-container"
          textClass="small"
          //icon={IconPhone}
          darkMode={darkMode}
          isPhone={true}
          valueLink={company?.phone}
          valueText={company?.phone}
        />
      </div>
    </div>
  );
};

export default CompanyPhoneInfo;
